import { Messages } from '../../../../gen-src/Localize';
import { PopoverWidget } from '@tableau/widgets';
import * as React from 'react';
import { Formatters } from '../../../../gen-src/Localize';
import { AppUrls } from '../../../app/AppUrls';
import { SearchResultItem } from '../../models/SearchResultTypes';
import { CardViewStyles } from './CardViewStyles';
import { ILocationInfo, LocationTypes } from '../../models/ILocationInfo';
import { ILink } from '../listView/dataGridCells/LinkCell';

export interface ContentCardProps {
  readonly urls: AppUrls;
  readonly content: SearchResultItem;
  readonly onResultItemSelected: () => void;
  readonly isSelected: boolean;
}

export abstract class ContentCard<Props extends ContentCardProps = ContentCardProps, State = {}> extends React.PureComponent<Props, State> {
  public getLastAccessedAt() {
    return this.props.content.lastAccessedAt ? Formatters.formatLongBestFitRelativeTime(new Date(this.props.content.lastAccessedAt)) : '';
  }

  protected getLinkForLocationType = (urls: AppUrls, isOwner: boolean, location?: ILocationInfo): ILink => {
    if (location) {
      switch (location.type) {
        case LocationTypes.PersonalSpace:
          return {
            text: Messages.personalSpaceGridLabel(),
            url: isOwner ? urls.personalSpaceUrl() : undefined,
          };
        case LocationTypes.Project:
          return {
            text: location.name,
            url: urls.projectUrl(location.id),
          };
        default:
          return {
            text: '',
            url: '',
          };
      }
    } else {
      return {
        text: '',
        url: '',
      };
    }
  };

  public renderInfoIconAndPopover(renderPopoverContent: () => JSX.Element) {
    return (
      <div>
        <PopoverWidget
          placement="bottom-start"
          popoverContent={renderPopoverContent()}
          title={''}
          triggerElement={
            <button className={CardViewStyles.InfoButton}>
              <img
                alt={Messages.More_info()}
                draggable={false}
                src={encodeSvg(
                  `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path fill="#666" fill-rule="evenodd" d="M8.5 1C12.6 1 16 4.4 16 8.5S12.6 16 8.5 16 1 12.6 1 8.5 4.4 1 8.5 1zm0 1C4.9 2 2 4.9 2 8.5S4.9 15 8.5 15 15 12.1 15 8.5 12.1 2 8.5 2zM9 7v5H8V7h1zm0-2v1H8V5h1z"/></svg>`
                )}
              />
            </button>
          }
        />
      </div>
    );
  }
}

export function getContentUrlForItem(content: SearchResultItem): string {
  return content.url || '';
}

// eslint-disable-next-line no-useless-escape
const svgDataUriRegExp: RegExp = /^data\:image\/svg\+xml/;

function encodeSvg(svg: string): string {
  return svgDataUriRegExp.test(svg) ? svg : `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
